// Pinterest Pixel & Conversion Tracking Helper
// Tag ID: 549764226499

const PINTEREST_TAG_ID = '549764226499';

/**
 * Initialize Pinterest Pixel
 * Should be called once when app loads
 */
export const initPinterestPixel = () => {
  if (window.pintrk) return; // Already initialized

  // Pinterest base code - initialize tracking object
  const loadPinterestScript = (scriptUrl) => {
    if (!window.pintrk) {
      window.pintrk = function() {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments));
      };
      const pintrk = window.pintrk;
      pintrk.queue = [];
      pintrk.version = "3.0";
      const script = document.createElement("script");
      script.async = true;
      script.src = scriptUrl;
      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  };

  loadPinterestScript("https://s.pinimg.com/ct/core.js");

  window.pintrk('load', PINTEREST_TAG_ID);
  window.pintrk('page');
};

/**
 * Track a Pinterest event
 * @param {string} eventName - Pinterest event name
 * @param {object} data - Event data
 */
export const trackPinterestEvent = (eventName, data = {}) => {
  if (window.pintrk) {
    window.pintrk('track', eventName, data);
  }
};

/**
 * Track page visit
 */
export const trackPageVisit = () => {
  trackPinterestEvent('pagevisit');
};

/**
 * Pre-defined Pinterest events for DesiFirms
 */
export const pinterestEvents = {
  // Track page visit
  pageVisit: () => trackPinterestEvent('pagevisit'),

  // Track user signup
  signup: (email = '') => {
    const data = { lead_type: 'registration' };
    if (email) {
      data.em = email; // Pinterest will hash this
    }
    trackPinterestEvent('signup', data);
  },

  // Track lead (inquiry, contact form)
  lead: (leadType = 'inquiry', data = {}) => {
    trackPinterestEvent('lead', {
      lead_type: leadType,
      ...data
    });
  },

  // Track search
  search: (query) => {
    trackPinterestEvent('search', {
      search_query: query
    });
  },

  // Track category view
  viewCategory: (categoryName) => {
    trackPinterestEvent('viewcategory', {
      category_name: categoryName
    });
  },

  // Track business listing view (like viewing a product)
  viewBusiness: (businessName, category = '') => {
    trackPinterestEvent('pagevisit', {
      line_items: [{
        product_name: businessName,
        product_category: category
      }]
    });
  },

  // Track when user starts listing their business
  addToCart: (businessName) => {
    trackPinterestEvent('addtocart', {
      line_items: [{
        product_name: businessName || 'Business Listing'
      }]
    });
  },

  // Track subscription/checkout initiation
  checkout: (planName, value = 0) => {
    trackPinterestEvent('checkout', {
      value: value,
      currency: 'AUD',
      line_items: [{
        product_name: planName
      }]
    });
  },

  // Custom event for business listing created
  businessCreated: (businessName, category = '') => {
    trackPinterestEvent('custom', {
      event_name: 'business_listing_created',
      content_name: businessName,
      content_category: category
    });
  }
};

export default {
  init: initPinterestPixel,
  track: trackPinterestEvent,
  events: pinterestEvents
};
